module.exports = {
  methods:
    loadTaskInfo: (data) ->
      Loader.on()
      @tasks_resources.get @loadTaskInfoSuccess, @unknownError, id: data.task.id

    loadTaskInfoSuccess: (data) ->
      @selected_task = data.task
      EventsBus.$emit 'confirm-modal-show', id: 'create-template-modal'
      Loader.off()

    sendEmail: (data) ->
      Loader.on()
      template = data.attr.template
      params = {
        id: @selected_task.id
        subject: template.subject
        body: template.body
        signature: template.signature
        send_email: true
      }
      @tasks_resources.save_template_and_send_email @sendEmailSuccess, @unknownError, params

    sendEmailSuccess: (data) ->
      Loader.off()
      alertify.success('E-mail disparado com sucesso')
      @selected_task.markAsDone()
      EventsBus.$emit 'Task::Done', @selected_task

    saveTemplate: (data) ->
      Loader.on()
      template = data.attr.template
      params = {
        id: @selected_task.id
        subject: template.subject
        body: template.body
        signature: template.signature
        send_email: false
      }
      @tasks_resources.save_template_and_send_email @saveTemplateSuccess, @unknownError, params

    saveTemplateSuccess: (data) ->
      Loader.off()
      alertify.success('Tarefa atualizada com sucesso')
}



// WEBPACK FOOTER //
// ./src/helpers/manual_tasks/list_wrapper.coffee